import { AppRoute } from '@agentselly/immodossier-shared';
import { createFileRoute } from '@tanstack/react-router';
import {
  OAuthCallback,
  OAuthSuccessPage,
  OAuthFailurePage,
} from '~/components/OAuthCallback';

export const Route = createFileRoute('/auth/oauth/callback/$provider' as any)({
  component: function Body() {
    return (
      <OAuthCallback
        providers={[
          'google',
          'apple',
          'microsoft',
          'github',
          'facebook',
        ]}
      />
    );
  },
});

export const OAuthSuccessRoute = createFileRoute('/auth/success' as any)({
  component: function Body() {
    return <OAuthSuccessPage />;
  },
});

export const OAuthFailureRoute = createFileRoute('/auth/failure' as any)({
  component: function Body() {
    return <OAuthFailurePage />;
  },
});
